'use client';

import { createContext, useDeferredValue, useContext, type PropsWithChildren } from 'react';
import { useYmmForm } from '../hooks/use-ymm-form';

export type YmmFormContextValue = ReturnType<typeof useYmmForm>;

const YmmFormContext = createContext<YmmFormContextValue | null>(null);

export function YmmFormProvider(props: PropsWithChildren) {
  const value = useYmmForm();
  const deferredValue = useDeferredValue(value, value);
  return (
    <YmmFormContext.Provider value={deferredValue}>
      {props.children}
    </YmmFormContext.Provider>
  );
}

export function useYmmFormContext(): YmmFormContextValue {
  const context = useContext(YmmFormContext);
  if (context == null) {
    throw new Error('useYmmFormContext must be used within a YmmFormProvider');
  }
  return context;
}
